<template>
  <span class="demand-address">{{ address }}</span>
</template>

<script>
  export default {
    props: {
      address: {
        type: String,
        default: "",
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demand-address {
    color: $primary;
  }
</style>
